import { render, staticRenderFns } from "./ManageProduct.modal.vue?vue&type=template&id=b19467a2"
import script from "./ManageProduct.modal.vue?vue&type=script&lang=ts"
export * from "./ManageProduct.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageProduct.modal.vue?vue&type=style&index=0&id=b19467a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports